var Vendd = (function (Vendd) {
	'use strict';

	var getCartModelOptions = {
		// ignoreExternalModules: false do not use it unless your are forcing a value. the default behaviour will be resolved server side from cart widget config attribute ConfigAttributes_CartIgnoreExternalModulesDefault
		// add other options if needed
	};

    var pending = false;
	Vendd.Cart.PendingMessages = null;
	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.DownLoadExcel, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.DownLoadExcelSuccess(response));
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.DownLoadExcelFailure(response));
		}

		var options = {
			url: 'EcomService.svc/GetCartItemsToExcel',
			data: {
				param: envelope.message.data
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});
	
	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.GetModel, Vendd.Cart, function (envelope) {

		if (pending === true) {
			return false;
		};

		function onSuccess(response) {
			model = response.data ? $.extend(true, {}, response.data, { LangCode: LhApp.Context.Language, CurrCode: LhApp.Context.Currency.Code}) : response.data;

			if (venddProjectConfigs.CartAvailabilityRestrictionMessages) {
				try {
					if (Vendd.Cart.PendingMessages) model.Cart.PendingMessages = $.merge([], Vendd.Cart.PendingMessages);
				} catch (ex) {
					model.Cart.PendingMessages = null;
				}
				Vendd.Cart.PendingMessages = null;
			}

			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ShowMessages(response));
            Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Changed(model));

            Vendd.Cart.SetClientModel(model);
			pending = false;
		}

		function onFailure(response) {

			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			pending = false;
		}

		var itemId = 0, templateCode = "";
		if (LhApp.Context.Item !== undefined) {
			itemId = LhApp.Context.Item.Id;
		}

		if (LhApp.Context.Item) {
		    templateCode = LhApp.Context.Item.Template;
		}

		var dataOptions = {
			currentItemId: itemId,
			templateCode: templateCode,
			ignoreExternalModules: envelope.message && envelope.message.data && envelope.message.data.ignoreExternalModules // when undefined this will not be null in server
		};

		var options = {
			data: dataOptions,
		    url: 'api/Cart/GetCartViewModel' + '?lang=' + LhApp.Context.Language, //todo perikstath -> this should be resolved by the rewriter and be like /el/
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		if (model != null && model != undefined && Vendd.Cart.GetClientModel() != null && document.cookie.indexOf('ForceClearCartLocalStorage') == -1) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Changed(model));
			return true;
		}

		pending = true;
        Cookies.remove('ForceClearCartLocalStorage', { path: '/' });

		pending = true;
		Vendd.Service.call(options);

		return true;
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, Vendd.Cart, function (envelope) {
        if (envelope && !envelope.message.data.IsLocalStorageCache)
            Vendd.MessageBus.publishAsync(Vendd.Newsletter, new Vendd.Newsletter.Messages.UpdateNewLetterVariables(2, null));
    });

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Add, Vendd.Cart, function (envelope) {
        function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.AddCompleted(response));
			if (venddProjectConfigs.CartAvailabilityRestrictionMessages) {
				Vendd.Cart.PendingMessages = null;
				try {
					Vendd.Cart.PendingMessages = JSON.parse(response.data).Messages;
				} catch (ex) {
					Vendd.Cart.PendingMessages = null;
				}
			}
			if (response.success && (response.code === 'OperationSuccesful' || response.code === 'OperationSuccesfulLastPieceAddedToCart')) {
				Vendd.Cart.ClearClientModel();

				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ProductAdded(envelope.message.data.id, envelope.message.data.skuId, response.data));
				
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ShowMessages(response));
 
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
				
			} else if (response.success && response.code === 'AlreadyInCart') {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.AlreadyInCart(envelope.message.data.id));
			} else if (response.success && response.code === 'ValidationError') {
			    Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Warning(response));
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			}
		}

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.AddCompleted(response));
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

        var options = {
            url: 'EcomService.svc/AddToCart',
            data: {
                item: {
                    id: envelope.message.data.id,
                    skuId: envelope.message.data.skuId,
                    path: envelope.message.data.path,
					qty: parseFloat(envelope.message.data.qty).toFixed(venddProjectConfigs.NumberOfDecimals ? venddProjectConfigs.NumberOfDecimals : 2),
                    extraAttributes: envelope.message.data.extraAttributes,
                    bundleItems: envelope.message.data.bundleItems,
                    recipeItems: envelope.message.data.recipeItems,
					comboItems: envelope.message.data.comboItems,
					enhancedInfo: envelope.message.data.enhancedInfo,
					isDefaultRecipeQuantitiesIncluded: true
                }
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.MultipleAdd, Vendd.Cart, function (envelope) {
		var data = {
			items: envelope.message.data
		};

        function onSuccess(response) {
            Vendd.Cart.ClearClientModel();

            if (response.success && response.code === 'OperationSuccesful') {
                Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.MultipleAddSuccess(response));
            } else if (response.success && response.code === 'PartialValidationError') {
                Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.MultipleAddSuccess(response));
                Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Warning(response));
            } else if (response.success && response.code === 'ValidationError') {
                Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Warning(response));
            } else {
                Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
            }
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/MultipleAddToCart',
			data: data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.MultipleAddSuccess, Vendd.Cart, function (envelope) {
		Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));	
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Remove, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success) {
				var removedProduct = model.Cart.Items.find(function (x) { return envelope.message.data.id == x.Id; });

				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ProductRemoved(envelope.message.data.id, removedProduct.ProductId, removedProduct.VariantId));

				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
		    } else
		        Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));

		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/RemoveFromCart',
			data: envelope.message.data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.MultipleRemove, Vendd.Cart, function (envelope) {
        var data = {
            ids: envelope.message.data
        };

        function onSuccess(response) {
            Vendd.Cart.ClearClientModel();

            if (response.success) {
                Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.MultipleRemoveSuccess(response));
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
            } else {
                Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
            }
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
        }

        var options = {
            url: 'EcomService.svc/MultipleRemoveFromCart',
            data: data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.SetQuantity, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success && (response.code === 'OperationSuccesful' || response.code === 'OperationSuccesfulLastPieceAddedToCart')) {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.SetQuantitySuccess(response));
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ShowMessages(response)); 
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
			} else if (response.success && response.code === 'ValidationError') {
			    Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Warning(response));
			} else
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/SetCartItemQty',
			data: {
				item: {
					id: envelope.message.data.id,
					qty: envelope.message.data.qty
				}
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.SetQuantities, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ShowMessages(response));
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
			} else
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed());
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed());
		}

		var options = {
			url: 'EcomService.svc/SetCartItemsQty',
			data: {
				items: envelope.message.data.items
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.UpdateBundleItems, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success) {

				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ShowMessages(response));
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));

			} else
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));

		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/UpdateBundleItems',
			data: {
				item: {
					id: envelope.message.data.id,
					bundleItems: envelope.message.data.bundleItems
				}
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ApplyExtraAllowanceOrCharge, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
			}
			else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			}
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/SetAllowanceOrCharge',
			data: {
				item: {
					itemId: envelope.message.data.itemId,
					shopAllowanceorChargeId: envelope.message.data.shopAllowanceorChargeId,
				}
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.DisableExtraAllowanceOrCharge, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
			}
			else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			}
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/RemoveAllowanceOrCharge',
			data: {
				item: {
					itemId: envelope.message.data.itemId,
					shopAllowanceorChargeId: envelope.message.data.shopAllowanceorChargeId,
				}
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.SetGiftwrap, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
			}
			else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			}
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/SetCartItemGiftWrap',
			data: {
				item: {
					id: envelope.message.data.id,
					wrapId: envelope.message.data.wrapId,
					message: envelope.message.data.message
				}
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.SetGiftwraps, Vendd.Cart, function (envelope) {

		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
			}
			else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			}
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed());
		}

		var options = {
			url: 'EcomService.svc/SetCartItemsGiftWrap',
			data: {
				items: envelope.message.data.items
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.SetGiftCard, Vendd.Cart, function (envelope) {

		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

            if (response.success) {
                Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GiftCardApplySuccess(envelope));
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GiftCardApplyFailed(response));
			};
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GiftCardApplyFailed(response));
		}

		var options = {
			url: 'EcomService.svc/SetGiftCard',
			data: {
				code: envelope.message.data.code,
				amount: envelope.message.data.amount
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.AddGiftCartEmailAddress, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel());
			    Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.AddGiftCartEmailAddressSuccess());
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			};
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/AddGiftCartEmailAddress',
			data: {
				items: envelope.message.data.items,
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ClearAllGiftCards, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			};
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/ClearAllGiftCards',
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ClearGiftCard, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();
			if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			};
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/ClearGiftCard',
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Clear, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();

			if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ClearSuccess(response));
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
			}
			else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			}
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/ClearCart',
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.UpdateCartProductReplacingTypes, Vendd.Cart, function (envelope) {
        function onSuccess(response) {
            Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.UpdateCartProductReplacingTypesSuccess(response));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.UpdateCartProductReplacingTypesFailed(response));
        }

        var options = {
            url: 'api/Cart/UpdateCartProductReplacingTypes',
            data: {
                parameters: envelope.message.data
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        }

        Vendd.Service.call(options);
    });

    /*Coupons*/
	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ApplyCoupon, Vendd.Cart, function (envelope) {
        function onSuccess(response) {
	        Vendd.Cart.ClearClientModel();
            if (response.success) {
                Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ApplyCouponSuccess(envelope));
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));				
	        } else {
	            Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
	        };
	    }

	    function onFailure(response) {
	        Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
	    }

	    var options = {
	        url: 'EcomService.svc/SetCoupon',
	        data: {
	            code: envelope.message.data.code
	        },
	        onSuccess: onSuccess,
	        onFailure: onFailure
	    };

	    Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ClearCoupon, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			if (response.success) {
				Vendd.Cart.ClearClientModel();
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));				
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			};
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/ClearCoupon',
			data: {
				code: envelope.message.data.code
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ClearCoupons, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();
			if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));				
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			};
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/ClearCoupons',
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
    });

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ApplyExternalCoupon, Vendd.Cart, function (envelope) {
	    function onSuccess(response) {
	        Vendd.Cart.ClearClientModel();
	        if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
	        } else {
	            Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
	        };
	    }

	    function onFailure(response) {
	        Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
	    }

	    var options = {
	        url: 'api/ExternalCoupon/SetExternalCouponCode',
	        data: {
	            code: envelope.message.data.code
	        },
	        onSuccess: onSuccess,
	        onFailure: onFailure
	    };

	    Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ClearExternalCoupon, Vendd.Cart, function (envelope) {
        function onSuccess(response) {
            if (response.success) {
                Vendd.Cart.ClearClientModel();
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
            } else {
                Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
            };
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
        }

        var options = {
            url: 'api/ExternalCoupon/RemoveExternalCouponCode',
            data: {
                code: envelope.message.data.code
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ClearExternalCoupons, Vendd.Cart, function (envelope) {
        function onSuccess(response) {
            Vendd.Cart.ClearClientModel();
            if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
            } else {
                Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
            };
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
        }

        var options = {
            url: 'api/ExternalCoupon/ClearExternalCoupons',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

	/*GiftCards*/
	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ClearGiftCard, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();
			if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
			};
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/ClearGiftCard',
			data: {
				code: envelope.message.data.code
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	var dontLoadOnLoginSuccess;
	Vendd.MessageBus.subscribe(Vendd.User.Messages.Login, Vendd.Cart, function (envelope) {
		dontLoadOnLoginSuccess = envelope.message.data.options && envelope.message.data.options.isLoginForm;
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.LoginSuccess, Vendd.Cart, function (envelope) { 
		if (dontLoadOnLoginSuccess)
			return;
		Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.LogoutSuccess, Vendd.Cart, function (envelope) {
		Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ApplyShippingData, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();
			if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ApplyShippingDataSuccess(response));
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ApplyShippingDataFailed(response));
			};
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ApplyShippingDataFailed(response));
		}

		var options = {
			url: 'CartService.svc/ApplyShippingData',
			data: {
				countryCode: envelope.message.data.countryCode,
				postCode: envelope.message.data.postCode,
				areaId: envelope.message.data.areaId,
				shippingMethodId: envelope.message.data.shippingMethodId,
				shippingCompanyId: envelope.message.data.shippingCompanyId
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.GetShippingModel, Vendd.Cart, function (envelope) {

		function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetShippingModelSuccess(response));
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetShippingModelFailed(response));
		}

		var options = {
			url: 'CartService.svc/GetShippingViewModel',
			data: {
				countryCode: envelope.message.data.countryCode,
				postCode: envelope.message.data.postCode,
				areaId: envelope.message.data.areaId,
				shippingMethodId: envelope.message.data.shippingMethodId,
				shippingCompanyId: envelope.message.data.shippingCompanyId
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.AddOrderItemsToCart, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();
			if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.AddOrderItemsToCartSuccess(response));
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.AddOrderItemsToCartFailed(response));
			};
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.AddOrderItemsToCartFailed(response));
		}

		var options = {
			url: 'EcomService.svc/AddOrderItemsToCart',
			data: envelope.message.data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.AddMultipleSkusToCart, Vendd.Cart, function (envelope) {
        function onSuccess(response) {
            Vendd.Cart.ClearClientModel();
            if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.AddMultipleSkusToCartSuccess(response));
                Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
            } else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.AddMultipleSkusToCartFailed(response));
            };
        }

        function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.AddMultipleSkusToCartFailed(response));
        }

        var options = {
            url: 'EcomService.svc/AddMultipleSkusToCart',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
	});

	Vendd.Cart.ClearClientModel = function () {
		localStorage.removeItem('CurrentCartModel');
	};

	Vendd.Cart.GetClientModel = function () {
	    var mdl = JSON.parse(localStorage.getItem("CurrentCartModel"));

	    return LhApp.Function.validateClientModel(mdl)
            ? $.extend({ IsLocalStorageCache: true }, mdl)
            : null;
	};

	Vendd.Cart.SetClientModel = function (mdl) {
	    localStorage.setItem('CurrentCartModel', JSON.stringify(mdl));
	};

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.SetDeliveryPoint, Vendd.Cart, function (envelope) {
        function onSuccess(success) {
            if (success)
                window.location.reload();
        }

        function onFailure(response) {
        }

        var options = {
            url: 'ProductListService.svc/SetDeliveryPoint',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.SetDigitalCare, Vendd.Cart, function (envelope) {

		function onSuccess(response) {
			Vendd.Cart.ClearClientModel();
			if (response.success) {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.SetDigitalCareSuccess(envelope));
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.SetDigitalCareFailure(response));
			};
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.SetDigitalCareFailure(response));
		}

		var options = {
			url: 'EcomService.svc/SetDigitalCare',
			data: {
				IsDigitalCareSelected: envelope.message.data.IsDigitalCareSelected
			},
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});
	
	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.GetPromotedDiscounts, Vendd.Cart, function (envelope) {

		function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetPromotedDiscountsSuccess(response));
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetPromotedDiscountsFailure(response));
		}

		var options = {
			url: 'api/cart/GetPromotedDiscounts',
			data: envelope.message.data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Cart.Messages.CheckSameDayDeliveryAvailability, Vendd.Cart, function (envelope) {
		function onSuccess(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.CheckSameDayDeliveryAvailabilitySuccess(response));
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.CheckSameDayDeliveryAvailabilityFailure(response));
		}

		var options = {
			url: 'EcomService.svc/CheckSameDayDeliveryAvailability',
			data: envelope.message.data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	var model = Vendd.Cart.GetClientModel();

	//this should be moved to every place that requires this component's data. e.g. cart widget AND in case your page DOES NOT contain that widget then you have to make sure theres somewhere this call 
	(function () {
		var defaultCallExecuted;
		function defaultCall() {
			if (Vendd.User.SessionState && !defaultCallExecuted) {
				defaultCallExecuted = true;

				if (Vendd.User.SessionState.IsNewSession)
					Vendd.User.ClearClientModel();

				if (venddProjectConfigs.CartModelEnabled && !venddProjectConfigs.SiteIsLocked) {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.GetModel(getCartModelOptions));
				}
			}
		}
		defaultCall();
		Vendd.MessageBus.subscribe(Vendd.User.Messages.GetSessionStateSuccess, Vendd.Cart, function (envelope) {
			defaultCall();
		});
	})();

	return Vendd;

})(Vendd || {});